module.exports = __webpack_public_path__ + "static/media/plus.d5840ba2.png";